import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';

import { BaseComponent } from '../../../../core/components/base/base.component';
import { describeReferralFailure } from '../../../../core/models/referral.model';
import { FeedbackService } from '../../../../core/services/feedback.service';
import { ReferralService } from '../../../../core/services/referral.service';

export interface ReferralLinkRequestDialogData {
  linkId: string;
  groupId: string;
  /** The Inbox row's title: "<practice> wants to link with your practice". */
  title: string;
}

/**
 * Another MedicAI practice asking to link with this one, in the practice OWNER's Inbox (owner, 2026-09-22;
 * tasks/referral-invite-unified.md). Only the owner sees the item, and the server refuses anyone else's answer.
 */
@Component({
  selector: 'app-referral-link-request-dialog',
  templateUrl: './referral-link-request-dialog.component.html',
  styleUrls: ['../referral-note-review-dialog/referral-note-review-dialog.component.scss'],
})
export class ReferralLinkRequestDialogComponent extends BaseComponent {
  isSaving = false;
  actionError: string | null = null;

  constructor(
    private referralService: ReferralService,
    private dialogRef: MatDialogRef<ReferralLinkRequestDialogComponent, { changed?: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: ReferralLinkRequestDialogData,
    fs: FeedbackService,
    md: MatDialog,
  ) {
    super(fs, md);
  }

  answer(response: 'accept' | 'decline'): void {
    if (this.isSaving) return;
    this.isSaving = true;
    this.actionError = null;
    this.referralService.respondPracticeLink(this.data.linkId, response, this.data.groupId).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => { this.isSaving = false; this.dialogRef.close({ changed: true }); },
      error: (error) => {
        this.isSaving = false;
        this.actionError = describeReferralFailure(error, 'The request could not be answered. Please try again.');
      },
    });
  }

  close(): void {
    this.dialogRef.close({});
  }
}
